import React, { useState } from "react";
// react component for creating dynamic tables
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import { Search, CSVExport } from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
// import { Collapse } from "reactstrap";
import { Button as Button2 } from "reactstrap";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { CardGiftcard, ArrowBack, LocalShipping } from "@material-ui/icons";

import { getBookedSlots, getAllActiveDrivers, sortDeliveryOrders, getAllDelayedOrders } from "../../network/ApiAxios";
import { redirectToLogout, zeroFill, extractOrderId, getOrderStatusCode } from "common/SharedFn";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SchedulingTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [bookedSlots, setBookedSlots] = useState([]);
  const [driversList, setDriversList] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [driverId, setDriverId] = useState(0);
  const [executeUpdateSequence, setExecuteUpdateSequence] = useState(false);
  const [isUpdatingSequence, setIsUpdatingSequence] = useState(false);
  const [delayedOrders, setDelayedOrders] = useState([]);

  // const [isFromCollapseChange, setIsFromCollapseChange] = useState(false);
  const [scheduleDate, setScheduleDate] = useState();
  // const [openedCollapses, setOpenedCollapses] = useState([]);
  let history = useHistory();
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // const collapsesToggle = collapse => {
  //   // if (openedCollapses.includes(collapse)) {
  //     var index = openedCollapses.indexOf(collapse);
  //     if (index !== -1) {
  //       setOpenedCollapses(openedCollapses.splice(index, 1));
  //     // }
  //   } else {
  //       openedCollapses.push(collapse);
  //       setOpenedCollapses(openedCollapses);
  //   }
  //   console.log(JSON.stringify(openedCollapses));
  //   setIsFromCollapseChange(true);
  // };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchScheduling = async () => {
    setIsLoading(true);
    setBookedSlots([]);
    try {
      const response = await getBookedSlots(new Date(scheduleDate), driverId);
      const delayedOrdersResponse = await getAllDelayedOrders();
      const { data } = response;
      if (data.result.isSuccess) {
        if (driversList == null || driversList.length === 0) {
          const responseDrivers = await getAllActiveDrivers();
          setDriversList(responseDrivers.data.data);
        }

        // Store delayed orders data
        if (delayedOrdersResponse.data.result.isSuccess) {
          setDelayedOrders(delayedOrdersResponse.data.data);
        } else {
          setDelayedOrders([]);
        }

        setBookedSlots(data.data /*.map((prop) => makeTableRow(prop))*/);
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch schedule " + ex);
      setDelayedOrders([]);
    }
    setIsLoading(false);
  };


  const updateSequence = async (ordersSequenced) => {
    setExecuteUpdateSequence(false);
    setIsUpdatingSequence(true);
    try {
      const response = await sortDeliveryOrders(ordersSequenced);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Sequence Updated Successfully");
      } else {
        showErrorNotification(data.result.description);
      }
    } catch (ex) {
      showErrorNotification("Failed to update sequence");
    }
    setIsUpdatingSequence(false);
  };


  useAsyncEffect(async () => {
    if (scheduleDate == null) {
      var scheduleDateStored = localStorage.getItem("searchScheduleDate");
      if (
        scheduleDateStored != null &&
        scheduleDateStored.toUpperCase() !== "NULL"
      ) {
        setScheduleDate(new Date(scheduleDateStored));
      } else {
        setScheduleDate(new Date().setDate(new Date().getDate()));
      }
    }
    if (scheduleDate != null) {
      fetchScheduling();
    }
  }, [
    scheduleDate,
    driverId,
    // isFromCollapseChange
  ]);

  const makeTableRow = (info) => {
    return {
      ...info,
    };
  };

  const isDelayedOrder = (orderId, orderStatus) => {
    // Get all delay entries for this order
    const relatedDelays =delayedOrders.filter(d => String(d.orderId) === String(orderId));
    if (relatedDelays.length === 0) {
      return false;
    }

    // Get the last (latest) delay entry
    const latestDelay = relatedDelays[relatedDelays.length - 1];
    const type = latestDelay.type;

    // Apply type-based rules to exit if it's no longer delayed
    if (
      (type === 0 && orderStatus >= 3) ||
      (type === 1 && orderStatus >= 7) ||
      (type === 2 && orderStatus >= 5)
    ) {
      return false;
    }

    return true;
  };


  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">Schedule</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              <div className="py-4 table-responsive">
                <Grid container className="pl-4">
                  <Grid item xs={12} sm={12}>
                    <form>
                      Date &emsp;
                      <div style={{ display: "inline-block" }}>
                        <DatePicker
                          timeCaption="Start Date"
                          selected={scheduleDate}
                          customInput={<OutlinedInput />}
                          onChange={(date) => {
                            localStorage.setItem("searchScheduleDate", date);
                            setScheduleDate(date);
                          }}
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>{" "}
                      &emsp;
                      <div
                        style={{
                          display: "inline-block",
                          marginBottom: "20px",
                        }}
                      >
                        <Select
                          value={driverId}
                          onChange={(e) => {
                            setDriverId(e.target.value);
                          }}
                          IconComponent={KeyboardArrowDown}
                        >
                          <MenuItem value={0}>All Drivers</MenuItem>
                          {driversList.map(function (driver, i) {
                            return (
                              <MenuItem value={driver.id}>
                                {driver.fullNameEn}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                      &emsp;{" "}
                    </form>
                  </Grid>
                </Grid>
                {isLoading ? (
                  <Box
                    component={Grid}
                    container
                    justifyContent="center"
                    className="justify-content-center"
                  >
                    <div className="text-center" style={{ width: "20%" }}>
                      <LoadingAnimation />{" "}
                    </div>
                  </Box>
                ) : (
                  bookedSlots.map(function (bSlot, i) {
                    return bSlot.availabilitySlotUtilizationDto.utilized ===
                      0 &&
                      bSlot.availabilitySlotUtilizationDto.available === 0 &&
                      (bSlot.bookedSlotDataDtoList == null ||
                        bSlot.bookedSlotDataDtoList.length === 0) ? (
                      ""
                    ) : (
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box display="flex">
                                <b style={{ flexGrow: 1 }}>
                                  {bSlot.availabilitySlot.startTime} -{" "}
                                  {bSlot.availabilitySlot.endTime} (Utilized:{" "}
                                  {
                                    bSlot.availabilitySlotUtilizationDto
                                      .utilized
                                  }{" "}
                                  - Available:{" "}
                                  {
                                    bSlot.availabilitySlotUtilizationDto
                                      .available
                                  }
                                  )
                                </b>
                                {(bSlot.bookedSlotDataDtoList != null && bSlot.bookedSlotDataDtoList.length !== 0 && driverId !== 0) ? <Button2
                                  color="info"
                                  size="sm"
                                  type="button"
                                  disabled={isUpdatingSequence}
                                  onClick={() => {
                                    updateSequence(bSlot.bookedSlotDataDtoList);
                                  }
                                  }
                                >
                                  Save
                                </Button2> : ''}
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        // role="tab"
                        // onClick={() => collapsesToggle(i)}
                        // aria-expanded={openedCollapses.includes(
                        //   i
                        // )}
                        ></CardHeader>
                        <Box
                          alignItems="center"
                          marginTop="5px!important"
                          marginLeft="15px!important"
                        // marginBottom="5px!important"
                        >
                          {/* <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes(i)}
            >   */}
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell width={(driverId !== 0) ? '20%' : '30%'}>Desc.</TableCell>
                                <TableCell width="20%">
                                  City
                                </TableCell>
                                <TableCell width="20%">
                                  Current Status
                                </TableCell>
                                <TableCell width="30%">
                                  Action Datetime
                                </TableCell>
                                {(driverId !== 0) ? <TableCell width="10%">Sequence</TableCell> : ''}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bSlot.bookedSlotDataDtoList.map(function (
                                item,
                                i
                              ) {
                                const isDelayed = isDelayedOrder(extractOrderId(item.id), getOrderStatusCode(item.currentStatus.split(' (')[0]));
                                return (
                                  <TableRow
                                    strippedRows
                                    style={{
                                      backgroundColor: isDelayed ? "#FDF6C0" : "inherit"
                                    }}
                                  >
                                    <TableCell>
                                      <p style={{ fontColor: "black" }}>
                                        <Box
                                          component={
                                            item.type == 2
                                              ? CardGiftcard
                                              : LocalShipping
                                          }
                                        />{" "}
                                        &ensp; {item.type == 2 ? "C" : ""}
                                        {zeroFill(item.id, 5)}{" "}
                                        {item.type == 2
                                          ? " Welcome Kit"
                                          : item.type == 1
                                            ? "Dropoff"
                                            : "Pickup"}
                                      </p>
                                    </TableCell>
                                    <TableCell>
                                      <p style={{ fontColor: "black" }}>
                                        {item.city}
                                      </p>
                                    </TableCell>
                                    <TableCell>
                                      <p style={{ fontColor: "black" }}>
                                        {item.currentStatus}
                                      </p>
                                    </TableCell>
                                    <TableCell>
                                      <p style={{ fontColor: "black" }}>
                                        {item.lastActionDatetime}
                                      </p>
                                    </TableCell>
                                    {(driverId !== 0) ? <TableCell>
                                      <OutlinedInput
                                        type="number"
                                        placeholder="Seq"
                                        defaultValue={item.seq ?? 0}
                                        onChange={(e) =>
                                          (item.seq = e.target.value)
                                        }
                                      />
                                    </TableCell> : ''}
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                          {/* </Collapse> */}
                        </Box>
                      </Card>
                    );
                  })
                )}
              </div>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default SchedulingTable;
